// Run this example by adding <%= javascript_pack_tag 'news' %> to your desired file.

import React from 'react'
import ReactDOM from 'react-dom'
import News from '../news'

const rootElement = document.getElementById('news')
const type = rootElement.dataset.type

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<News />, rootElement)
})
